export default __webpack_public_path__ + "static/media/demande_rattachement.59d61afb.svg";